import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { CarouselType } from './carouselcomponent';

export interface CarouselCSSStyle extends UIComponentCSSStyle
{
    getListRowCSSStyle(): object;
    getArrowsCSSStyle(carouseType: CarouselType, direction: string): object;
}

export class CarouselCSSStyleImpl extends UIComponentCSSStyleImpl implements CarouselCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            listStyleType: "none",
            width: "100%",
            height: "100%",
            display: "flex",
            flexFlow: "row wrap"
        };
    }

    getArrowsCSSStyle(carouseType: CarouselType, direction: string): object
    {
        if(carouseType === CarouselType.BANNER)
        {
            if(direction === "left")
            {
                return { 
                    backgroundImage: "none", marginTop: "-40px",left: "10px", right: "auto"
                };
            }
            else
            {
                return { 
                    backgroundImage: "none",marginTop: "-50px", transform: "rotateZ(-180deg)", left: "auto", right: "10px"
                };
            }
        }
        else
        {
            if(direction === "left")
            {
                return { 
                    backgroundImage: "none",left: "10px", right: "auto", width: '33px !important', height: '20px !important'
                };
            }
            else
            {
                return { 
                    backgroundImage: "none", left: "auto",transform: "rotateZ(-180deg)", right: "10px", width: '33px !important', height: '20px !important'
                };
            }
        }
    }
    
    getListRowCSSStyle(): object 
    {
        return {
            width: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            marginTop: "20px",
            justifyContent: 'flex-start', 
            borderRadius: '8px'
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/carousel/carouselcss.tsx